import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

interface SectionBlockProps {
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}

export function SectionBlock({
  title,
  description,
  action,
  children,
  className,
  contentClassName,
}: SectionBlockProps) {
  return (
    <section className={cn("space-y-4", className)}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="max-w-2xl space-y-1.5">
          <h2 className="font-gotham text-xl font-semibold text-neutral-900">
            {title}
          </h2>
          {description ? (
            <p className="font-inter text-sm leading-6 text-neutral-600">
              {description}
            </p>
          ) : null}
        </div>
        {action ? <div className="sm:shrink-0">{action}</div> : null}
      </div>
      <div className={contentClassName}>{children}</div>
    </section>
  );
}
